import React, { useState } from "react";
import {
  BaseButtons,
  DropDownWithDisplay,
  LoadingPopUp,
  TextInputField,
} from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import VehicleCard from "../vehicle-card/VehicleCard";

const AddVehiclePopUp = ({
  activeView,
  setActiveView,
  SubmitHandler,
  regsitrationNr,
  setRegistrationNr,
  vinNr,
  setVinNr,
  licenceNr,
  setLicenceNr,
  engineNr,
  setEngineNr,
  make,
  setMake,
  series,
  setSeries,

  setToastPop,
  setMessage,
  GetSeriesDataLinkedToMake,
  makeArray,
  seriesArray,
  loading,
  setLoading,
  searchRegister,
  setSearchRegister,
  setSeriesArray,
  auth,
  setRefresh,
  refresh,
  setPopUpTitle,
  setLinkedUserIdNumber,
  linkedUserIdNumber,
}) => {
  const [selectedMake, setSelectedMake] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(false);

  const [isShortVin, setIsShortVin] = useState(false);
  const [opened, setOpened] = useState(null);

  const [vehicleSearchArray, setVehicleSearchArray] = useState(null);

  const SelectVehicle = (vehicle) => {
    setSearchRegister(false);
    setRegistrationNr(vehicle.registerNr);
    setVinNr(vehicle.vinNr);
    setLicenceNr(vehicle.licenceNr);
    setEngineNr(vehicle.engineNr);
    setMake(vehicle.make);
    setSeries(vehicle.series);
  };

  const DataClear = () => {
    setSearchRegister(true);
    setRegistrationNr("");
    setVinNr("");
    setLicenceNr("");
    setEngineNr("");
    setMake(null);
    setSeries(null);
    setSeriesArray(null);
    setOpened(false);
  };

  const SearchEnatisMasterData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/enatis/checkVehicleData",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            regNum: regsitrationNr,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.enatisVehicles) {
        setLoading(false);
        setVehicleSearchArray(respnseData.enatisVehicles);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  return (
    <div
      style={{
        height: activeView === "add" ? "100%" : 0,
        width: "100%",
        //   borderStyle: "solid",
        borderRadius: 15,
        //   borderColor: colors.primaryBlue,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        transition: "height 0.3s",
        //position: "absolute",
        //bottom: 0,
      }}
    >
      <div
        style={{
          flex: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            height: vehicleSearchArray && searchRegister ? "100%" : 0,
            width: "100%",
            backgroundColor: colors.white,
            position: "absolute",
            zIndex: 300,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            overflowY: "auto",
            overflowX: "hidden",
            transition: "all 0.3s",
            opacity: vehicleSearchArray && searchRegister ? 1 : 0,
            bottom: 0,
          }}
        >
          {vehicleSearchArray ? (
            vehicleSearchArray.length >= 1 ? (
              vehicleSearchArray.map((vehicle, index) => {
                return (
                  <div
                    style={{
                      width: "60%",
                      height: 200,
                      margin: 20,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    key={index}
                  >
                    <VehicleCard
                      registrationNr={vehicle.registerNr}
                      vin_nr={vehicle.vinNr}
                      licenceNr={vehicle.licenceNr}
                      engineNr={vehicle.engineNr}
                      make={vehicle.make}
                      series={vehicle.series}
                      notList={true}
                      selector={true}
                      onSelectClcik={() => SelectVehicle(vehicle)}
                    />
                  </div>
                );
              })
            ) : (
              <div
                style={{ marginBottom: 40, fontWeight: "bold", fontSize: 20 }}
              >
                NO VEHICLES FOUND
              </div>
            )
          ) : null}
          <div>
            <BaseButtons
              label={"CONTINUE"}
              width={150}
              borderRadius={4}
              backgroundColor={colors.greenDark}
              onClick={() => {
                setSearchRegister(false);
              }}
            />
          </div>
        </div>
        {searchRegister ? (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                padding: 20,
                backgroundColor: colors.white,
                borderRadius: 10,
              }}
            >
              <div style={{ width: 300, marginBottom: 30 }}>
                Lets do a quick search to see if we already have the data for a
                matching vehicle
              </div>
              <TextInputField
                labelTitle={"Register Nr"}
                mini={true}
                size={300}
                reqiredCheck={true}
                rule={regsitrationNr.length}
                count={7}
                onChange={(e) => setRegistrationNr(e.target.value)}
              />
              <div style={{ height: 40 }} />
              <BaseButtons
                label={"SEARCH"}
                width={330}
                backgroundColor={colors.greenLight}
                borderRadius={10}
                onClick={() => SearchEnatisMasterData()}
              />
            </div>
          </div>
        ) : (
          <div
            style={{
              flex: 1,
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                flex: 0.5,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",

                height: "100%",
              }}
            >
              <div
                style={{
                  marginTop: 120,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  marginBottom: 10,
                }}
              >
                <div style={{ fontWeight: "bold" }}>
                  EXAMPLE OF VEHICLE TO ADD
                </div>
              </div>
              <div
                style={{
                  height: 200,
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <VehicleCard
                  registrationNr={regsitrationNr ? regsitrationNr : "waiting"}
                  vin_nr={vinNr ? vinNr : "waiting"}
                  licenceNr={licenceNr ? licenceNr : "waiting"}
                  engineNr={engineNr ? engineNr : "waiting"}
                  make={make ? make : "waiting"}
                  series={series ? series : "waiting"}
                  notList={true}
                />
              </div>
              <div style={{ flex: 1, width: "100%" }}>
                <DropDownWithDisplay
                  title={"MAKE"}
                  tagline={"(Select the make of your vehicle)"}
                  data={makeArray ? makeArray : []}
                  selected={make}
                  setSelected={setMake}
                  opened={opened}
                  setOpened={setOpened}
                  makeDropDown={true}
                  GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                  setLoading={setLoading}
                  auth={auth}
                  setMessage={setMessage}
                  setRefresh={setRefresh}
                  refesh={refresh}
                  setToastPop={setToastPop}
                  setPopUpTitle={setPopUpTitle}
                  setSelectedMake={setSelectedMake}
                  setSeries={setSeries}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Series"}
                  width={"100%"}
                  size={"78%"}
                  marginTop={0}
                  value={series}
                  onChange={(e) => setSeries(e.target.value)}
                  // reqiredCheck={true}
                  // rule={regsitrationNr.length}
                  // count={7}
                />

                <div
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      width: "78%",
                      marginTop: 40,
                      marginBottom: 20,
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    LINKED USER
                  </div>
                  <TextInputField
                    mini={true}
                    labelTitle={"ID NUMBER"}
                    width={"100%"}
                    size={"78%"}
                    marginTop={0}
                    value={linkedUserIdNumber}
                    onChange={(e) => setLinkedUserIdNumber(e.target.value)}
                    // reqiredCheck={true}
                    // rule={regsitrationNr.length}
                    // count={7}
                  />
                </div>
                {/* {seriesArray && selectedMake === make ? (
                  <DropDownWithDisplay
                    title={"SERIES"}
                    tagline={"(Select your vehicles series)"}
                    data={seriesArray ? seriesArray : []}
                    selected={series}
                    setSelected={setSeries}
                    opened={opened}
                    setOpened={setOpened}
                    seriesDropDown={true}
                    setLoading={setLoading}
                    auth={auth}
                    setMessage={setMessage}
                    setRefresh={setRefresh}
                    refesh={refresh}
                    setToastPop={setToastPop}
                    make={make}
                    GetSeriesDataLinkedToMake={GetSeriesDataLinkedToMake}
                    setPopUpTitle={setPopUpTitle}
                  />
                ) : null} */}
              </div>
            </div>
            <div
              style={{
                flex: 0.5,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                // backgroundColor:colors.greenLight
              }}
            >
              <div
                style={{ marginBottom: 20, fontSize: 16, fontWeight: "bold" }}
              >
                BASIC INFORMATION
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderStyle: "solid",
                  borderWidth: 3,
                  borderColor: colors.greenLight,
                  width: "80%",
                  borderRadius: 8,
                  height: "56%",
                  position: "relative",
                }}
              >
                <div style={{ position: "absolute", top: -50, right: 0 }}>
                  {isShortVin ? (
                    <BaseButtons
                      label={"FULL VIN"}
                      width={100}
                      backgroundColor={colors.greenLight}
                      borderRadius={10}
                      onClick={() => setIsShortVin(false)}
                    />
                  ) : (
                    <BaseButtons
                      label={"SHORT VIN"}
                      width={100}
                      backgroundColor={colors.greenLight}
                      borderRadius={10}
                      onClick={() => setIsShortVin(true)}
                    />
                  )}
                </div>
                <TextInputField
                  mini={true}
                  labelTitle={"Register Nr"}
                  width={"100%"}
                  size={"70%"}
                  marginTop={0}
                  value={regsitrationNr}
                  onChange={(e) => setRegistrationNr(e.target.value)}
                  reqiredCheck={true}
                  rule={regsitrationNr.length}
                  count={7}
                />

                <TextInputField
                  mini={true}
                  labelTitle={"Vin Nr"}
                  width={"100%"}
                  size={"70%"}
                  value={vinNr}
                  onChange={(e) => setVinNr(e.target.value)}
                  reqiredCheck={true}
                  rule={vinNr.length}
                  count={isShortVin ? 5 : 17}
                />

                <TextInputField
                  mini={true}
                  labelTitle={"Licence Nr"}
                  width={"100%"}
                  size={"70%"}
                  value={licenceNr}
                  onChange={(e) => setLicenceNr(e.target.value)}
                  reqiredCheck={true}
                  rule={licenceNr.length}
                  count={9}
                />
                <TextInputField
                  mini={true}
                  labelTitle={"Engine Nr"}
                  width={"100%"}
                  size={"70%"}
                  value={engineNr}
                  onChange={(e) => setEngineNr(e.target.value)}
                  reqiredCheck={true}
                  rule={engineNr.length}
                  count={20}
                />
              </div>
            </div>
          </div>
        )}
        {/* back and close buttons */}
        <div style={{ position: "absolute", top: 10, left: 10, zIndex: 301 }}>
          <BaseButtons
            label={"CLOSE"}
            width={100}
            backgroundColor={colors.secondaryOrange}
            onClick={() => {
              setActiveView("catalog");
              setVehicleSearchArray(null);
              DataClear();
            }}
            borderRadius={10}
            z
          />
        </div>
        {/* next and complete buttons */}
        <div style={{ position: "absolute", top: 10, right: 10 }}>
          <BaseButtons
            label={"SUBMIT"}
            width={100}
            backgroundColor={colors.greenLight}
            borderRadius={10}
            onClick={() => SubmitHandler()}
            disabled={
              isShortVin
                ? make &&
                  series &&
                  regsitrationNr.length === 7 &&
                  vinNr.length >= 5 &&
                  licenceNr.length === 9 &&
                  engineNr.length === 20
                  ? false
                  : true
                : make &&
                  series &&
                  regsitrationNr.length === 7 &&
                  vinNr.length === 17 &&
                  licenceNr.length === 9 &&
                  engineNr.length === 20
                ? false
                : true
            }
          />
        </div>
        <div
          style={{
            position: "absolute",
            top: 20,
            fontSize: 18,
            fontWeight: "bold",
            color: colors.secondaryDarkBlue,
            left: 140,
          }}
        >
          ADD VEHICLE MASTER
        </div>
      </div>
    </div>
  );
};

export default AddVehiclePopUp;
